import { render, staticRenderFns } from "./Careers.vue?vue&type=template&id=cf0fb49a&scoped=true&"
import script from "./Careers.vue?vue&type=script&lang=ts&"
export * from "./Careers.vue?vue&type=script&lang=ts&"
import style0 from "./Careers.vue?vue&type=style&index=0&id=cf0fb49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0fb49a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('cf0fb49a', component.options)
    } else {
      api.reload('cf0fb49a', component.options)
    }
    module.hot.accept("./Careers.vue?vue&type=template&id=cf0fb49a&scoped=true&", function () {
      api.rerender('cf0fb49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/company/Careers.vue"
export default component.exports